export enum ErrorCode {
    FufSizeTooLarge = "FufSizeTooLarge",
    BadRequest = "BadRequest",
    UnknownError = "UnknownError",
}

export interface ErrorResponse {
    errorCode: ErrorCode;
    message: string;
}

class CandyApiError extends Error {
    public constructor(data: ErrorResponse | string) {
        if (typeof data === "string") {
            super(data);
            return;
        }
        super(`${data.errorCode}: ${data.message}`);
    }
}

export class ServerError extends CandyApiError {}

export class ConvertationError extends CandyApiError {}
